<template>
  <div class="msb">
    <div class="logo">
      <img src="../../assets/msb.png">
    </div>
    <div class="toHome" @click="toHome">
      <img src="../../assets/yuyue.png">
    </div>
    <div class="bottom">
      <div class="datas">数据来源：兴安盟博物馆</div>
      <div>联系方式：<span>0482-12345 0482-8375333</span></div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showAlert: true,
      data: ''
    };
  },

  methods: {
    toHome() {
      // alert(JSON.stringify(this.$route.query))
      this.getCode()
    },

    getCode() {
      location.href = `https://app.zwfw.nmg.gov.cn:4443/icity/auth2.0/authorize?app_id=c7d5a391-e069-488c-a1d5-ab6c7c39c430&redirect_uri=${encodeURIComponent('https://museum.chaoxing.com/ticket/vtwo/#/ticket/home?museumCode=xabwg')}&scope=auth_user&state={}`
    }
  },

  created() {
    this.data = location.href
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .msb{
    .logo{
      width: 7rem;
      margin: auto;
      margin-top: 1rem;
      img{
        width: 100%;
        object-fit: contain;
      }
    }
    .toHome{
      margin: auto;
      margin-top: 1rem;
      width: 2rem;
      img{
        width: 100%;
        object-fit: contain;
      }
    }
    .bottom{
      font-size: 0.35rem;
      font-weight: 500;
      line-height: 0.6rem;
      margin: auto;
      margin-top: 3rem;
      letter-spacing: 0.1rem;
      text-align: center;
      &.datas{
        width: 5.5rem;
        text-align: left;
      }
      span{
        letter-spacing: 0.05rem;
      }
    }
  }
</style>
